document.addEventListener('DOMContentLoaded', function() {
  
  // Find all modals and move them to body
  const existingModals = document.querySelectorAll('.bis-modal');
  
  existingModals.forEach(modal => {
    // Move modal to body to avoid CSS inheritance issues
    document.body.appendChild(modal);
  });
  
  // Check if buttons exist
  const notifyButtons = document.querySelectorAll('.bis-notify-button');
  
  // Handle notify button clicks
  notifyButtons.forEach(button => {
    
    button.addEventListener('click', function(e) {
      const modalId = this.getAttribute('data-modal-target');
      // If the button has been programmatically converted back into a normal
      // add-to-cart submit button (e.g. via variant mapping), don't hijack the
      // click. Allow the form submission/default behavior.
      if (!modalId) return;

      e.preventDefault();
      
      const modal = document.getElementById(modalId);
      
      if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
        
        // Reload Omnisend script if needed
        if (window.omnisend && window.omnisend.push) {
          window.omnisend.push(['init']);
        }
      } else {
        console.error('Modal not found with ID:', modalId);
      }
    });
  });

  // Handle close button clicks
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('bis-modal-close')) {
      const modal = e.target.closest('.bis-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  });

  // Handle overlay clicks
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('bis-modal-overlay')) {
      const modal = e.target.closest('.bis-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  });

  // Handle ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.bis-modal').forEach(modal => {
        if (modal.style.display === 'block') {
          modal.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
    }
  });
});